<template>
  <!-- 人员信息 -->
  <div class="edu_pages">
    <div class="edu_pages_content_top">
      <div class="edu_header_title">管理的院系</div>
    </div>
    <div class="edu_pages_content">
      <div class="edu_pages_content_header">
        <div class="inside_pages_right_content_top_right line_div">
          <el-input
            size="mini"
            placeholder="院系名称"
            class="textInput"
            v-model.trim="requestData.schoolName"
          ></el-input>
          &nbsp;
          <el-button
            size="mini"
            type="primary"
            plain
            icon="el-icon-search"
            @click="searchHiddenDangerData"
            >搜索</el-button
          >
        </div>
      </div>
      <div class="edu_pages_content_body">
        <el-table
          :data="resData.list"
          style="width: 100%;
          height:100%;overflow:scroll;"
        >
          <el-table-column label="序号" width="90" align="center">
            <template slot-scope="scope">
              {{
                resData.pageSize * (resData.pageNum - 1) + scope.$index + 1
              }}
            </template>
          </el-table-column>
          <el-table-column prop="schoolName" label="院系名称" align="center" >
          </el-table-column>
          <el-table-column prop="logUrl" label="院系logo" width="102">
            <template slot-scope="scope">
              <el-image
                style="width:80px;height:80px"
                v-if="scope.row.logUrl"
                :src="$store.state.config.fileUrl + scope.row.logUrl"
                :preview-src-list="[
                  $store.state.config.fileUrl + scope.row.logUrl
                ]"
              >
              </el-image>
              <el-image
                style="width:80px;height:80px"
                v-if="!scope.row.logUrl"
                :src="require('@/assets/img/noData/no_img.png')"
                :preview-src-list="[require('@/assets/img/noData/no_img.png')]"
              >
              </el-image>
            </template>
          </el-table-column>

          <el-table-column prop="schoolPrincipal" label="院系负责人" align="center">
          </el-table-column>
          <el-table-column prop="schoolAddress" label="院系地址" align="center">
          </el-table-column>

          <el-table-column label="操作" align="center" width="200">
            <template slot-scope="scope">
              <div>
                <el-button
                  type="primary"
                  plain
                  size="mini"
                  @click="check(scope.row.schoolId)"
                  >查看隐患</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="edu_pages_content_bottom" v-if="resData.total > 0">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="resData.pageNum"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="requestData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="resData.total"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      requestData: {
        LogisticsId: JSON.parse(sessionStorage.getItem("eduInfo")).eduId, // 后勤总公司id
        schoolName: "", // 院系名称
        pageNum: 1,
        pageSize: 20
      },
      resData: {
        pageSize: 0,
        pageNum: 0,
        total: 0,
        pages: 0,
        list: []
      }
    };
  },
  created() {
    this.getDataList();
  },
  mounted() {},
  watch: {},
  computed: {
    eduInfo() {
      return JSON.parse(sessionStorage.getItem("eduInfo"));
    },
    userInfo() {
      return JSON.parse(sessionStorage.getItem("userInfo"));
    }
  },
  methods: {
    // 隐患搜索
    searchHiddenDangerData() {
      this.requestData.pageNum = 1;
      this.getDataList();
    },

    handleSizeChange(val) {
      this.requestData.pageNum = 1;
      this.requestData.pageSize = val;
      console.log(`每页 ${val} 条`);
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.requestData.pageNum = val;
      console.log(`当前页: ${val}`);
      this.getDataList();
    },
    async getDataList() {
      let req = this.requestData;
      let res = await this.$Http.getAllCollegesLogistics(req, true);
      if (res.code == 200) {
        this.resData.pageSize = res.data.pageSize || 0;
        this.resData.pageNum = res.data.pageNum || 0;
        this.resData.total = res.data.total || 0;
        this.resData.pages = res.data.pages || 0;
        this.resData.list = res.data.list || [];
      } else if (res.code == 101) {
        this.resData.pageSize = 0;
        this.resData.pageNum = 0;
        this.resData.total = 0;
        this.resData.pages = 0;
        this.resData.list = [];
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    check(id) {
      this.$store.commit('updateCollegeId',id);
      this.$Common.pageJump('/l_hidden_Danger',2);
    }
  }
};
</script>
<style scoped>
.el-select,
.el-input {
  width: 170px;
}
input::-webkit-input-placeholder {
  color: #c0c4cc;
}
input::-moz-input-placeholder {
  color: #c0c4cc;
}
input::-ms-input-placeholder {
  color: #c0c4cc;
}
</style>
